import $ from 'jquery';

export default {
  filesize($el){
    $.ajax({
      type: "HEAD",
      url: $el.data('filesize-url'),
      success: function(d, t, x){
        // Using base 10 (international SI units) is fine for this use case
        var KB = 1000;
        var MB = 1000000;
        var GB = 1000000000;
        var filesizeBytes = parseInt(x.getResponseHeader('Content-Length'));
        var filesizeHuman = false;
        switch ( true ) {
          case filesizeBytes < KB:
            filesizeHuman = filesizeBytes + ' b';
            break;
          case filesizeBytes < MB:
            filesizeHuman = (filesizeBytes/KB).toFixed(1) + ' kb';
            break;
          case filesizeBytes < GB:
            filesizeHuman = (filesizeBytes/MB).toFixed(1) + ' mb';
            break;
        }
        if ( filesizeHuman ) {
          $el.text(`(${filesizeHuman})`);
        }
      }
    });
  },
}